module.exports = __webpack_public_path__ + "img/MW_Groups_FB_Instructions_3.ba99aa47.gif";